import AttachmentsPreview from '@sdk/attachments/components/AttachmentsPreview/AttachmentsPreview';
import { useToggle } from '@sdk/common/hooks/useToggle';

import { Article as ArticleType } from '@web/newsfeed/types/Article';
import { ArticleHeader } from '@web/newsfeed/Article/ArticleHeader/ArticleHeader';
import { MarkdownDisplayWrapper } from '@web/components/MarkdownDisplayWrapper';
import { ArticleFooter } from '@web/newsfeed/Article/ArticleFooter/ArticleFooter';
import { ArticleComments } from '@web/newsfeed/Article/ArticleComments/ArticleComments';

import { ArticleBox, ArticleWrapper } from './article.styles';
import { useArticle } from './article.hooks';

export type Props = {
  article: ArticleType;
};

export const Article = ({ article }: Props) => {
  const { isOn: areCommentsVisible, toggle: toggleComments } = useToggle();
  const { parsedContent } = useArticle(article);

  return (
    <ArticleBox>
      <ArticleWrapper>
        <ArticleHeader article={article}></ArticleHeader>
        <MarkdownDisplayWrapper dangerouslySetInnerHTML={parsedContent} />
        <div>
          {!!article.attachments?.length && (
            <AttachmentsPreview attachments={article.attachments} />
          )}
          <ArticleFooter
            article={article}
            toggleComments={toggleComments}
            onLikeClick={() => console.log('like!')} // @TODO add like support
          />
          {areCommentsVisible && <ArticleComments article={article} />}
        </div>
      </ArticleWrapper>
    </ArticleBox>
  );
};
